function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;stroke-width:0.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.25 0.25)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M11.633,0A11.633,11.633,0,1,0,23.266,11.633,11.646,11.646,0,0,0,11.633,0Zm0,21.463a9.831,9.831,0,1,1,9.831-9.831A9.842,9.842,0,0,1,11.633,21.463Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.226 6.145)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M146.934,139.743h-3.6v-3.6a.9.9,0,1,0-1.8,0v3.6h-3.6a.9.9,0,1,0,0,1.8h3.6v3.6a.9.9,0,0,0,1.8,0v-3.6h3.6a.9.9,0,0,0,0-1.8Z",
  transform: "translate(-137.022 -135.238)"
})));

var SvgAddMore = function SvgAddMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.766,
    height: 23.766,
    viewBox: "0 0 23.766 23.766",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addMore.1e036f2b.svg";
export { ForwardRef as ReactComponent };